<template>
    <div class="card-group mb-4">
        <div class="card box mr-2" style="border: 0;">
            <div class="box mb-4" style="box-shadow: none">
                <div class="box-header">
                    <h5>{{ productSku.id > 0 ? 'Edit' : 'Add'}} Sku</h5>
                </div>
                <div class="box-content">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label><strong>SKU</strong></label>
                                <input maxlength="255" type="text" class="form-control" v-model="productSku.sku">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label><strong>Size</strong></label>
                                <input maxlength="255" type="text" class="form-control" v-model="productSku.size">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label><strong>Price</strong></label>
                                <input maxlength="255" type="text" class="form-control" v-model="productSku.price">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <button type="button" class="btn btn-primary" @click="submitSku()">{{ productSku.id > 0 ? 'Edit' : 'Add'}} Sku</button>
                        </div>
                    </div>
                    <div class="font-12 text-muted mt-2"><i>*Note: Need to click 'save' button to update database</i></div>
                </div>
            </div>
        </div>
        <div class="card box ml-2" style="border: 0;">
            <div class="box mb-4" style="box-shadow: none">
                <div class="box-header d-flex justify-content-between">
                    <h5>List Skus</h5>
                    <button type="button" class="btn btn-sm btn-primary" @click="addSku()">Add new sku</button>
                </div>
                <div class="box-content">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">SKU</th>
                                    <th scope="col">Size</th>
                                    <th scope="col">Price</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="productSkus.length > 0">
                                <tr v-for="(sku, index) in productSkus" :key="index">
                                    <th scope="row">{{ index + 1}}</th>
                                    <td>{{ sku.sku }}</td>
                                    <td>{{ sku.size }}</td>
                                    <td>${{ sku.price }}</td>
                                    <td>
                                        <a href="javascript:void(0)" class="btn btn-sm btn-outline-success mr-3" @click="editSku(sku)"><i class="icon-edit"></i> Edit</a>
                                        <button type="button" class="btn btn-sm btn-outline-danger" @click="deleteSku(sku.sku)"><i class="icon-remove"></i> Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="5" align="center">No product sku</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="font-12 text-muted mt-2"><i>*Note: Click 'save' button to update database</i></div>
                </div>
            </div>    
        </div>
        <input type="hidden" name="product_skus" :value="JSON.stringify(this.productSkus)">
        <input type="hidden" name="deleted_skus" :value="JSON.stringify(this.deletedSkus)">
    </div>
</template>

<script>
const defaultSKU = {
    id: -1,
    sku: '',
    size: '',
    price: ''
}
export default {
    props: ['pid', 'pProductSkus'],
    data() {
        return {
            productSkus: this.pProductSkus,
            productSku: {
                id: -1,
                sku: '',
                size: '',
                price: ''
            },
            deletedSkus: []
        };
    },
    methods: {
        deleteSku(sku) {
            if(confirm('Are you sure to delete this product?')) {
                this.productSkus = _.reject(this.productSkus, {sku});
                this.deletedSkus = [...this.deletedSkus, sku];
            }
        },
        editSku(sku) {
            this.productSku = _.cloneDeep(sku);
        },
        addSku() {
            this.productSku = _.cloneDeep(defaultSKU);
        },
        async submitSku() {
            if (_.isEmpty(this.productSku.sku)
                || _.isEmpty(this.productSku.sku)
                || _.isEmpty(this.productSku.sku)) {
                alert('Please fill sku, price, size');
                return;
            }

            let checkedSku = await axios.get(`/admin/isDuplicateSku?sku=${this.productSku.sku}`);
            checkedSku = checkedSku.data;
            if (checkedSku && checkedSku.id && checkedSku.id !== this.productSku.id) {
                alert('Duplicate sku, please choose other sku');
                return;
            }
            
            if (this.productSku.id > -1) {
                _.forEach(this.productSkus, (sku, key) => {
                    if (sku.id == this.productSku.id) {
                        console.log(sku, this.productSku);
                        this.productSkus[key] = this.productSku;
                    }
                });
            } else {
                this.productSkus = [...this.productSkus, this.productSku];
            }
            this.productSku = _.cloneDeep(defaultSKU);
        }
    }
}
</script>
